import React from 'react';

const Review = () => {
    return (
        <div>
            <h1>this is review page now under developer this page</h1>
        </div>
    );
};

export default Review;